<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box"></div>
            <div class="about-wrap">
                <div class=" about">
                    <div class="logo"><div class="img" :style="{backgroundImage:'url('+util.autoImage(sponsor.logo)+')'}"></div></div>
                    <div class=" tit">{{sponsor.title}}</div>
                    <div class=" desc">{{sponsor.desc}}</div>
                    <div class="link" v-if="sponsor.link" @click="util.toLink(sponsor.link,'','_blank')"><span>查看更多</span></div>
                </div>
                <div class=" info">
                    <div class="info-tit">
                        <div class="left item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)">精彩视频</div>
                        <div class="left item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)">资料下载</div>
                        <div class="left item" :class="[tab == 3 ? 'active' : '']" @click="setTab(3)" style="display: none;">相关会议日程列表</div>
                    </div>
                    <div class="tab">
<!--                        <div class="video-box" :class="[tab == 1 ? 'active' : '']">-->
<!--                            <div class=" video">-->
<!--                                <video controls id="partner_video" loop v-if="sponsor.video" :poster="util.autoImage(sponsor.video)+'?x-oss-process=video/snapshot,t_55000,f_jpg,m_fast'">-->
<!--                                    <source :src="util.autoImage(sponsor.video)" >-->
<!--                                </video>-->
<!--                                <div class="mark" v-if="video_play_show">-->
<!--                                    <div class="play" @click="playVideo"></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
						<div class="download-box" :class="[tab == 1 ? 'active' : '']">
							<div class="list">
								<div class="item" v-for="item in sponsor.video">
									<div class="left tit-box video">
										<div class="middle">
											<div class=" tit">{{item.title}}</div>
										</div>
									</div>
									<!--                                    <div class="left size">{{item.size}}MB</div>-->
									<div class="right link video" ><a href="javascript:;" @click="showVideo(item)" :download="item.title">观看视频</a></div>
								</div>
							</div>
						</div>
                        <div class="download-box" :class="[tab == 2 ? 'active' : '']">
                            <div class="list">
                                <div class="item" v-for="item in sponsor.file">
                                    <div class="left tit-box" :class="[item.type == 1 ? 'word' : item.type == 2 ? 'pdf' : 'ppt']">
                                        <div class="middle">
                                            <div class=" tit">{{item.title}}</div>
                                        </div>
                                    </div>
<!--                                    <div class="left size">{{item.size}}MB</div>-->
                                    <div class="right link" ><a href="javascript:;" @click="showDownload(item)" :download="item.title">下载</a></div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="plan-box" :class="[tab == 3 ? 'active' : '']" style="display: none;" >
                            <div class="list">
                                <div class="item" :class="[item.live_code ? '' : 'no-link']" v-for="item in sponsor.session" @click="toMudu(item)">
                                    <div class="left time" :data="item.live_start">{{tool.date.formatDate('H:i',item.live_start)}}-{{tool.date.formatDate('H:i',item.live_end)}}</div>
                                    <div class="left tit-box">
                                        <div class="element tit">{{item.title}}</div>
                                        <div class="clear author"><span>{{item.speaker}}</span><span>{{item.speaker_job}}</span></div>
                                        <div class="clear author" v-if="item.speaker2"><span>{{item.speaker2}}</span><span>{{item.speaker2_job}}</span></div>
                                        <div class="clear author" v-if="item.speaker3"><span>{{item.speaker3}}</span><span>{{item.speaker3_job}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="action-wrap" style="display: none;">
                <div class="left sealer">
                    <div class="title">
                        <div class="tit">销售专员</div>
                    </div>
                    <div class="list">
                        <div class="time" v-html="sponsor.service_time"></div>
                        <div class="item" v-for="item in sponsor.sealer">
                            <div class="left avatar" :style="{backgroundImage: 'url('+util.autoImage(item.avatar)+')'}"></div>
                            <div class="left info">
                                <div class="middle">
                                    <div class="username">{{item.username}}</div>
                                    <div class="job">
                                        <p v-html="item.job"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="right link" v-if="user_info.id"><a :href="'mailto:'+item.email" @click="report(item)">联系我们</a></div>
                            <div class="right link" v-else><a href="javascript:;" @click="util.showAuth({show:true})">联系我们</a></div>
                        </div>
                    </div>
                </div>
                <div class="left qa" style="display: none;">
                    <div class="title">
                        <div class="tit">赞助商问答</div>
                    </div>
                    <div class="box">
                        <div class="list" :class="user_info.id ? 'active' : ''" v-infinite-scroll="getSponsorQuestion"  infinite-scroll-distance="10">
                            <div class="item" v-for="item in question">
                                <div class="question"><i>{{item.user ? item.user.username : 'DELL用户'}}咨询：</i>{{item.question}}</div>
                                <div class="answer" v-if="item.answer"><i>官方回答：</i>{{item.answer?item.answer:"暂未回复"}}</div>
                            </div>
                            <div class="footer">{{footer == 1 ? "上拉加载更多" : footer == 2 ? "加载中" :"没有更多内容了"}}</div>
                        </div>
                        <div class="submit-box">
                            <div class="left input">
                                <input type="text" placeholder="请输入您想咨询的问题" v-model="key">
                            </div>
                            <div class="right btn" :class="[key ? '' : 'hidden']" @click="submit">发送</div>
                        </div>
                        <div class="tip" v-if="!user_info.id">登录后才可以提交问题，请先 <i @click="toLogin">登录</i></div>
                    </div>
                </div>
            </div>
        </div>
        <down-load :file="file_info" v-if="file_info.file_id" @hideDownload="hideDownload"></down-load>
		<video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import DownLoad from "../../../components/pc/DownLoad";
	import VideoFloat from "@/components/pc/VideoFloat.vue";
    export default {
        name: 'detail',
        data() {
            return {
                query:"",
                video_play_show:true,
                tab:1,
                sponsor:{},
                question:[],
                key:"",
                footer:1,
                page:1,
                file_info:{},
                ids:[],

				video_info:{}
            }
        },
        components:{
            Crumbs,DownLoad,VideoFloat
        },
        computed:{
            user_info(){
                return this.$store.state.user_info
            },
            crumbs() {
            	return {title:this.sponsor.type == 1 ? '全球赞助商' : this.sponsor.type == 2 ? '特别鸣谢' : '赞助商',min_title:"SPONSOR"}
            },
        },
        methods: {
			hideVideo(){
				this.video_info = {}
			},
			showVideo(item){
				this.video_info = {
					category_title:item.title,
					title:item.title,
					video:item.url
				}
			},
            report(item){
                this.http.request({
                    api:"sponsor/contact",
                    data:{
                        sponsor_id:this.query.sponsor_id,
                        sealer_id:item.id
                    },
                    success:()=>{

                    }
                })
            },
            toMudu(item){
                if(!item.live_code){
                    return false;
                }
                var url = this.global.MUDU_HOST +item.live_code;
                if(this.$store.state.user_info.id){
                    var router = this.$router.resolve({
                        path:"/auth",
                        query:{
                            live_code:item.live_code,
                            redirect:url
                        }
                    });
                    window.open(router.href, '_blank');
                }else{
                    var from = "/auth?live_code="+item.live_code+"&redirect="+url
                    this.util.showAuth({
                        show:true,
                        from:from
                    });
                }
            },
            showDownload(item){
                if(this.$store.state.user_info.id){
                    this.file_info = item;
                }else{
                    this.util.showAuth({
                        show:true
                    })
                }
            },
            hideDownload(){
                this.file_info = {};
            },
            setTab(tab){
                this.tab = tab;
                this.stopVideo();
            },
            stopVideo(){
                var video = document.getElementById('partner_video');
				video && video.pause();
            },
            playVideo(){
                var video = document.getElementById('partner_video');
                video.addEventListener('play',()=>{
                    this.video_play_show = false;
                })
                video.addEventListener('pause',()=>{
                    this.video_play_show = true;
                })
                video.play();
            },
            getSponsorDetail(){
                this.http.request({
                    api:"sponsor/getSponsorDetail",
                    data:{
                        sponsor_id:this.query.sponsor_id
                    },
                    success:(res)=>{
                        this.sponsor = res.sponsor;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getSponsorQuestion(){
                if(this.footer != 1){return false;}
                this.footer = 2;
                this.http.request({
                    api:"sponsor/getSponsorQuestion",
                    data:{
                        sponsor_id:this.query.sponsor_id,
                        page:this.page,
                        ids:this.ids.join(',')
                    },
                    success:(res)=>{
                        this.question = this.question.concat(res.question);
                        if(res.question.length < res.limit){
                            this.footer = 3;
                        }else{
                            this.footer = 1;
                            this.page = this.page + 1;
                        }
                    }
                })
            },
            toLogin(){
                this.util.toLink('/login',{
                    from:this.$route.path == '/login' ? '/' : this.$route.fullPath
                })
            },
            submit(){
                if(!this.key){
                    return false;
                }
                if(!this.user_info.id){
                    this.util.showAuth({
                        show:true,
                    });return  false;
                }
                this.http.request({
                    api:"sponsor/submitQuestion",
                    data:{
                        question:this.key,
                        sponsor_id:this.query.sponsor_id,
                    },
                    loading:true,
                    success:(res)=>{
                        this.ids.push(res.question_id);
                        this.question.push({
                            id:res.question_id,
                            question:this.key,
                            user:this.user_info
                        })
                        this.key = "";
                        this.$nextTick(()=>{
                            var element = document.querySelector(".qa .list");
                            element.scrollTop = element.scrollHeight;
                        })
                    }
                })
            },
            checkLogin(){
                if(!this.util.getAccessToken()){
                    this.util.showAuth({
                        show:true,
                        close_btn:true,
                    })
                }
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getSponsorDetail();
            this.getSponsorQuestion();
            this.checkLogin();
        },
        destroyed() {
            this.util.showAuth({
                show:false,
            })
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .wrap{padding: 20px;
		.about-wrap{overflow: hidden;width: 1200px;margin: 0 auto;display: flex;align-items: stretch;justify-content: space-between;
            .about{flex: 1; background: #fff;border-radius: 5px;overflow: hidden;
                .logo{height:100px;padding: 30px;
                    .img{width:300px;height:90px;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
                .tit{padding: 0 30px;font-size: 18px;line-height: 23px;margin-top: 10px;}
                .desc{padding: 0 30px;margin-top:10px;font-size: 14px;color:#929292;line-height: 24px;-webkit-line-clamp:5;white-space: pre-line}
                .link{width: 130px;height:40px;margin: 20px auto;background: #1D56C0;text-align: center;line-height: 40px;color:#fff;transition: all .3s ease;cursor: pointer;
                    span{padding-right: 15px;background: url("~@/assets/image/58.png") no-repeat right center;background-size: 7px;}
                }
            }
            .info{flex: 1;
                .info-tit{height:50px;line-height: 50px;background: #fff;
                    .item{width:180px;text-align:center;font-size: 16px;color:#565656;position: relative;cursor: pointer;}
                    .item.active::after{content: "";display: block;position: absolute;bottom:0;left:50%;width: 110px;height:5px;background: #1D56C0;margin-left: -55px;}
                }
                .video-box{height:330px;position: relative;margin-top: 20px;border-radius: 5px;overflow: hidden;display: none;
                    video{height:330px;display: block;object-fit: cover;}
                    .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.5);
                        .play{width:60px;height:60px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/4.png") no-repeat left center;background-size: contain;margin-left: -30px;margin-top: -30px;cursor: pointer;border-radius: 50%;}
                    }
                }
                .video-box.active{display: block;}
                .download-box{position: relative;margin-top: 20px;border-radius: 5px;overflow: hidden;display: none;background: #f3f3f3;
                    .list{padding: 0 30px;overflow: hidden;overflow-y: auto;
                        .item{padding: 20px 0;border-bottom: 1px solid #d7d7d7;background: #f3f3f3;overflow: hidden;
                            .tit-box{padding-left: 44px;width: 300px;
                                .middle{height:40px;
                                    .tit{font-size: 14px;width: 400px;}
                                    .m-tit{font-size: 12px;color:#565656;width: 300px;}
                                }
                            }
                            .tit-box.word{background: url("~@/assets/image/25_1.png") no-repeat left center;background-size: contain;}
                            .tit-box.pdf{background: url("~@/assets/image/23.png") no-repeat left center;background-size: contain;}
                            .tit-box.ppt{background: url("~@/assets/image/24.png") no-repeat left center;background-size: contain;}
                            .tit-box.video{background: url("~@/assets/image/90.png") no-repeat left center;background-size: contain;}
                            .size{text-align: center;line-height: 40px;font-size: 12px;margin-left: 20px;}
                            .link{line-height: 40px;font-size: 14px;padding-left:16px;background: url("~@/assets/image/25.png") no-repeat left center;background-size: 10px;margin-left: 20px;
                                a{color:#1D56C0;}
                            }
							.link.video{padding-left: 20px; background-image: url("~@/assets/image/91.png");background-size: 15px;}
                        }
                        .item:nth-last-child(1){border-bottom: none;}
                    }
                }
                .download-box.active{display: block;}
                .plan-box{height:330px;position: relative;margin-top: 20px;border-radius: 5px;overflow: hidden;display: none;background: #f3f3f3;
                    .list{height:330px;padding: 0 30px;overflow: hidden;overflow-y: auto;font-size: 14px;
                        .item{padding: 12px 0;border-bottom: 1px solid #d7d7d7;background: #f3f3f3;overflow: hidden;cursor: pointer;
                            .time{width: 110px;}
                            .tit-box{width: 380px;
                                .tit{font-weight: bold;font-size: 14px;}
                                .author{font-size: 12px;
                                    span{display: block;float: left;}
                                    span:nth-child(1){max-width: 40px;}
                                    span:nth-child(2){width: 280px;margin-left: 10px;}
                                }
                            }
                        }
                        .item.no-link{cursor: default;}
                        .item:nth-last-child(1){border-bottom: none;}
                    }
                }
                .plan-box.active{display: block;}
            }
        }
        .action-wrap{overflow: hidden;width: 1200px;margin: 40px auto 0;
            .sealer{width: 590px;
                .title{height:50px;line-height: 50px;color:#565656;background: #fff;border-bottom: 1px solid #f1f1f1;
                    .tit{position: relative;margin-left: 45px;display: inline-block;}
                    .tit::after{content: "";display: block;width: 50px;height:4px;background: #1D56C0;position: absolute;left:50%;margin-left: -25px;bottom:0;}
                }
                .list{padding:0 30px 30px;background: #fbfbfb;height:440px;overflow: hidden;overflow-y: auto;
                    .time{font-size: 14px;color:#1D56C0;height:50px;line-height: 50px;padding-left: 25px;background: url("~@/assets/image/56.png") no-repeat left center;background-size: 23px;}
                    .item{overflow: hidden;margin-bottom: 30px;
                        .avatar{width: 80px;height:80px;background-repeat: no-repeat;background-position: center center;background-size:cover;border-radius: 50%;background-image: url("~@/assets/image/5.png");}
                        .info{width:250px;margin-left: 15px;
                            .middle{height:80px;
                                .username{font-size: 17px;}
                                .job{font-size: 14px;line-height: 18px;color: #565656;white-space: pre-line; }
                            }
                        }
                        .link{width: 104px;height:35px;border:1px solid #0176ce;text-align: center;line-height: 35px;font-size: 14px;color:#0176ce;transition: all .3s ease;margin-top: 22px;cursor: pointer;
                            a{color:#0176ce}
                        }
                        .link:hover{background: #0176ce;transition: all .3s ease;color: #fff;
                            a{color:#fff}
                        }
                    }
                    .item:nth-last-child(1){margin-bottom: 0;}
                }
            }
            .qa{width: 610px;
                .title{padding-left: 25px; height:50px;line-height: 50px;color:#565656;background: #fff;border-bottom: 1px solid #f1f1f1;
                    .tit{position: relative;display: inline-block;}
                    .tit::after{content: "";display: block;width: 85px;height:4px;background: #0176ce;position: absolute;left:50%;margin-left: -42px;bottom:0;}
                }
                .box{background: #f1f1f1;padding: 20px 0 20px 20px;
                    .list{height: 340px;overflow: hidden;overflow-y: auto;
                        .item{margin-bottom: 20px;
                            .question{padding:12px 20px 10px;background: #fff;font-size: 13px;color:#565656;line-height: 20px;
                                i{font-weight: bold;}
                            }
                            .answer{padding:12px 20px 10px;background: #f6f6f6;font-size: 13px;color:#565656;line-height: 20px;
                                i{font-weight: bold;}
                            }
                        }
                        .footer{height:50px;line-height: 50px;text-align: center;font-size: 14px;color:#999;display: none;}
                    }
                    .list.active{height:370px;}
                    .submit-box{margin-top: 20px;overflow: hidden;border: 1px solid #038df4;border-radius: 5px;position: relative;background: #fff;
                        .input{height:40px;width: 100%;
                            input{width:480px;padding: 0 10px;height:40px; line-height: 40px;font-size: 14px;border: none;}
                        }
                        .btn{position: absolute;top:0;right:0; width: 90px;height:40px;line-height: 40px;text-align:center;background: #038df4;color:#fff;cursor: pointer;}
                    }
                    .tip{height:30px;line-height: 30px;color:red;font-size: 14px;display: none;
                        i{color:#3176c8;cursor: pointer;}
                    }
                }
            }
        }
    }
</style>

